import { render, staticRenderFns } from "./ComponentSubtitle.vue?vue&type=template&id=1f54fcde&scoped=true&"
var script = {}
import style0 from "./ComponentSubtitle.vue?vue&type=style&index=0&id=1f54fcde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54fcde",
  null
  
)

export default component.exports